module.exports = __webpack_public_path__ + "img/m_list_top.9971b364.png";